<template>
  <v-dialog v-model="openDialog" max-width="650" persistent>
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" class="display-inline" v-on="on">
        <slot />
      </div>
    </template>
    <v-card>
      <v-toolbar color="indigo" dark>
        <v-toolbar-title>Agent Oluştur</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form ref="form" v-model="isFormValid">
        <v-card-text>
          <QuickAgent
            :isFormValid="isFormValid"
            @update:agent="(a) => (agent = a)"
            v-model="agent"
            :showCompanyPhone="true"
            :showRole="false"
          />
        </v-card-text>
        <v-card-actions class="d-flex justify-content-end">
          <v-btn color="error" class="mr-2" @click="close">İptal</v-btn>
          <v-btn
            color="primary"
            class="mr-8"
            :disabled="!isFormValid"
            @click="saveAgent"
            >Kaydet</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import QuickAgent from "@/view/content/agent/QuickAgent.vue";
import { defineComponent } from "vue";
import { mapActions } from "vuex";

export default defineComponent({
  name: "CreateAgentModal",
  components: {
    QuickAgent,
  },
  data() {
    return {
      openDialog: false,
      isFormValid: true,
      agent: {},
    };
  },
  methods: {
    ...mapActions(["createAgent"]),
    close() {
      this.agent = {};
      this.openDialog = false;
      this.$refs.form.reset();
    },
    async saveAgent() {
      const valid = this.$refs.form.validate();
      if (!valid) {
        this.isFormValid = false;
        return;
      }
      if (!this.isUniqPhone()) {
        this.isFormValid = false;
        return;
      }
      this.agent.roles = [2];
      try {
        await this.createAgent(this.agent);
        this.$emit("refresh");
        this.$toast.success("Agent başarıyla yaratıldı.", {
          duration: 2000,
          position: "bottom-right",
        });
        this.close();
      } catch (error) {
        this.$toast.error(error[0].detail, {
          position: "bottom-right",
          duration: 2000,
        });
      }
    },
    isUniqPhone() {
      if (this.agent.phone === this.agent.company_phone) {
        this.$toast.error("Telefon numaraları aynı olamaz", {
          position: "bottom-right",
          duration: 2000,
        });
        return false;
      }
      return true;
    },
  },
});
</script>
